import axios from "axios";
import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY;
const API_KEY = process.env.REACT_APP_API_KEY;

export const decryptResponse = (encryptedData) => {
  if (!encryptedData || !encryptedData.includes(":")) {
    console.warn("❌ Invalid Encrypted Data Format:", encryptedData);
    return null;
  }
  try {
    const [ivHex, encryptedText] = encryptedData.split(":");
    const iv = CryptoJS.enc.Hex.parse(ivHex);
    const ciphertext = CryptoJS.enc.Hex.parse(encryptedText);
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext },
      CryptoJS.enc.Utf8.parse(SECRET_KEY),
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
    if (!decryptedString)
      throw new Error("Decryption resulted in empty string");
    return JSON.parse(decryptedString);
  } catch (error) {
    console.error("❌ Decryption Error:", error.message);
    return null;
  }
};
export const encryptApiKey = (apiKey) => {
  try {
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(
      apiKey,
      CryptoJS.enc.Utf8.parse(SECRET_KEY),
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return `${iv.toString(CryptoJS.enc.Hex)}:${encrypted.ciphertext.toString(
      CryptoJS.enc.Hex
    )}`;
  } catch (error) {
    console.error("❌ API Key Encryption Error:", error.message);
    return null;
  }
};

// Set axios default options globally
axios.defaults.withCredentials = true; // Ensure credentials (cookies) are sent with requests

// 🚀 Request Interceptor to Add Encrypted API Key
axios.interceptors.request.use(
  (config) => {
    if (API_KEY) {
      const encryptedKey = encryptApiKey(API_KEY);
      if (encryptedKey) {
        config.headers["api-key"] = encryptedKey;
      } else {
        console.warn("⚠️ Failed to encrypt API key!");
      }
    } else {
      console.warn("⚠️ API key is missing!");
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🔓 Decrypt Response
axios.interceptors.response.use(
  (response) => {
    if (response.data?.encryptedData) {
      try {
        response.data = decryptResponse(response.data.encryptedData);
      } catch (error) {
        console.error("Failed to decrypt response:", error.message);
      }
    } else {
    }
    return response;
  },
  (error) => Promise.reject(error)
);

export default axios;
